import { DateAdapter } from '@angular/material/core';
import { NavigatorService } from './../services/navigator.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TimestampFormatPipe } from '../commons/timestampFormatPipe';
import { GenericDetailComponent } from '../shared/GenericDetailComponent';
import { ResponseQueryByCriteria } from '../shared/dto/responseQueryByCriteria';

import { DeviceAziendaleService } from '../services/device-aziendali/device.service';
import { DeviceDTO } from '../shared/dto/device-aziendali/device';
import { DeviceTypeService } from '../services/device-aziendali/device-type.service';
import { DeviceTypeDTO } from '../shared/dto/device-aziendali/deviceType';
import { CollaboratoreDTO } from '../shared/dto/domain/collaboratore';
import { CollaboratoreService } from '../services/domain/collaboratore.service';
import { SoftwareDTO } from '../shared/dto/device-aziendali/software';
import { SoftwareService } from '../services/device-aziendali/software.service';

@Component({
  selector: 'app-device',
  templateUrl: './devicesDetail.component.html',
  styleUrls: ['./devicesDetail.component.scss']
})

export class DeviceDetailComponent extends GenericDetailComponent implements OnInit, OnDestroy {

  device: DeviceDTO;
  tipi: DeviceTypeDTO[] = [];
  collaboratori: CollaboratoreDTO[] = [];
  listaSoftware: SoftwareDTO[];

  constructor(
    private deviceService: DeviceAziendaleService,
    private deviceTypeService: DeviceTypeService,
    private collaboratoreService: CollaboratoreService,
    private softwareService: SoftwareService,
    activeRoute: ActivatedRoute,
    dialog: MatDialog,
    snackBar: MatSnackBar,
    timestampFormatPipe: TimestampFormatPipe,
    router: Router,
    navigatorService: NavigatorService,
    dateAdapter: DateAdapter<Date>) {
    super(
      navigatorService,
      dialog,
      router,
      dateAdapter,
      activeRoute,
      snackBar,
      timestampFormatPipe);
    this.form = new FormGroup({
      id:             new FormControl({ value: '', disabled: true }),
      codiceCespite:  new FormControl('', Validators.required),
      mac:            new FormControl('', Validators.required),
      serie:          new FormControl('', Validators.required),
      fattura:        new FormControl('', [ Validators.required, Validators.pattern('^[0-9]*$')  ]),  //solo numeri
      tipoId:         new FormControl(null, Validators.required),
      dataConsegna:   new FormControl(null),
      dataRiconsegna: new FormControl(null),      //facoltatio
      formattato:     new FormControl(false),   //boolean
      collaboratori:  new FormControl(''),    //se riconsegnato, non ha collaboratore
      software:       new FormControl([]),
      
      deleteDate: new FormControl({ value: '', disabled: true }),
      deleteUser: new FormControl({ value: '', disabled: true }),
      insertDate: new FormControl({ value: '', disabled: true }),
      insertUser: new FormControl({ value: '', disabled: true }),
      updateDate: new FormControl({ value: '', disabled: true }),
      updateUser: new FormControl({ value: '', disabled: true }),
      optLock:    new FormControl({ value: '', disabled: true }),
    });
  }

  ngOnInit() {
    this.device = new DeviceDTO();
    this.device.id = Number(this.activeRoute.snapshot.paramMap.get("id"));
    if (this.device.id != null && this.device.id != 0) {
      this.deviceRead();
    } else {
      this.device = new DeviceDTO();
    }

    this.deviceTypeService.typeList(
      0,
      9999,
      'ASC',
      'id',
      ''
    ).subscribe((res: ResponseQueryByCriteria<DeviceTypeDTO>) => {
      this.tipi = res.content;
    });

    this.collaboratoreService.collaboratoreList(
      0,
      9999,
      'ASC',
      'id',
      ''
    ).subscribe((res: ResponseQueryByCriteria<CollaboratoreDTO>) => {
      this.collaboratori = res.content;
    });

    this.softwareService.softwareList(
      0,
      9999,
      'ASC',
      'id',
      ''
    ).subscribe((res: ResponseQueryByCriteria<SoftwareDTO>) => {
      this.listaSoftware = res.content;
    });

  }

  deviceSave() {
    console.log(this.device.id);
    if (this.device.id == null) {
      this.deviceCreate();
    } else {
      this.deviceUpdate();
    }
  }

  deviceCreate() {
    if (this.form.valid) {
      this.formToDto();
      this.deviceService.create(this.device).subscribe(
        (res: DeviceDTO) => {
          this.snackBar.open("Salvataggio avvenuto con successo!", null, { duration: 3000 });
          this.device = res;
          this.dtoToForm();
          this.form.markAsPristine();
        }, (err: any) => {
          this.device.id = null;
          this.snackBar.open("Errore nel salvataggio!", null, { duration: 3000 });
          console.error("Errore salvataggio:", err);
        }
      );
    }
  }

  deviceUpdate() {
    if (this.form.valid && this.form.dirty) {
      this.confirm("Sei sicuro di voler sovrascrivere il device?").subscribe(result => {
        if (result) {
          this.formToDto();
          this.deviceService.update(this.device).subscribe(
            (res) => {
              this.snackBar.open("Salvataggio avvenuto con successo!", null, { duration: 3000 });
              this.deviceRead();
              this.form.markAsPristine();
            }, (err: any) => {
              this.snackBar.open("Errore nel salvataggio!", null, { duration: 3000 });
              console.error("Errore salvataggio:", err);
            }
          );
        }
      });
    }
  }

  deviceDelete() {
    this.confirm("Sei sicuro di voler cancellare questo device?").subscribe(result => {
      if (result) {
        this.formToDto();
        this.deviceService.delete(this.device.id).subscribe(
          (res) => {
            this.snackBar.open("Cancellazione avvenuta con successo!", null, { duration: 3000 });
            this.router.navigate(["/device"]);
          }
        );
      }
    });
  }

  deviceRead() {
    this.deviceService.read(this.device.id).subscribe(
      (res: DeviceDTO) => {
        this.device = res;
        this.device.id = res.id;
        this.dtoToForm();
      }
    );
  }

  
  compareSoftware(o1: any, o2: any): boolean {
  // Confronta gli oggetti tramite il loro ID
    return (o1 && o2) ? o1.id === o2.id : o1 === o2;
  }

  private formToDto(): void {
    this.device.id              = this.form.get("id").value;
    this.device.codiceCespite   = this.form.get("codiceCespite").value;
    this.device.mac             = this.form.get("mac").value;
    this.device.serie           = this.form.get("serie").value;
    this.device.fattura         = this.form.get("fattura").value;
    this.device.dataConsegna    = this.form.get("dataConsegna").value;
    this.device.dataRiconsegna  = this.form.get("dataRiconsegna").value;
    this.device.formattato      = this.form.get("formattato").value;
    this.device.tipo            = this.form.get("tipoId").value;

    // --- MODIFICA CORRETTIVA PER COLLABORATORE ---
    const collValue = this.form.get("collaboratori").value;
    
    // Controlliamo se è una stringa vuota o composta solo da spazi
    if (!collValue || collValue === "" || (typeof collValue === 'string' && collValue.trim() === "") ) {
        this.device.collaboratore = null;
    } else {
        this.device.collaboratore = collValue;
    }

    const rawSoftwareList = this.form.get("software").value;

    if (rawSoftwareList && rawSoftwareList.length > 0) {
        // trasformiamo (mappiamo) nella struttura che vuole il backend
        // Da: { id: 1, nome: 'Eclipse' } 
        // A:  { software: { id: 1, nome: 'Eclipse' } }
        this.device.software = rawSoftwareList.map(sw => {
            // se per caso è già nel formato giusto (es. caricamento modifica), lo lasciamo così
            if (sw.hasOwnProperty('software')) {
                return sw; 
            }
            // Altrimenti lo impacchettiamo
            return { software: sw };
        });
    } else {
        this.device.software = [];
    }

  }

  private dtoToForm(): void {
    this.form.get("id").setValue(this.device.id);
    this.form.get("codiceCespite").setValue(this.device.codiceCespite);
    this.form.get("mac").setValue(this.device.mac);
    this.form.get("serie").setValue(this.device.serie);
    this.form.get("fattura").setValue(this.device.fattura);
    this.form.get("formattato").setValue(this.device.formattato);
    this.form.get("tipoId").setValue(this.device.tipo);
    this.form.get("collaboratori").setValue(this.device.collaboratore);

    const rawSoftwareList = this.device.software;
    let data: any[] = [];

    if (rawSoftwareList && rawSoftwareList.length > 0) {
      /* serve ANY perche nella definizione del DTO a frontend c'è "softwareDTO",
      lui si aspetta di trovare un software dentro softwareDTO, ma non è come lo faccio arrivare qui */
      data = rawSoftwareList.map((wrapper: any) => {
        if (wrapper && wrapper.software) {
            return wrapper.software;
          }
          return wrapper; 
      });
    }
    
    this.form.get("software").setValue( data );

      
    const dataConsegnaString = this.device.dataConsegna;
    if (dataConsegnaString != null) {
      this.form.get("dataConsegna").setValue( new Date(dataConsegnaString) );
    }else {
    this.form.get("dataConsegna").setValue( null );
    }

    const dataRiconsegnaString = this.device.dataRiconsegna;
    if (dataRiconsegnaString != null) {
      this.form.get("dataRiconsegna").setValue( new Date(dataRiconsegnaString) );
    }else {
    this.form.get("dataRiconsegna").setValue( null );
    }
    
    this.form.get("deleteDate").setValue(this.device.deleteDate);
    this.form.get("deleteUser").setValue(this.device.deleteUser);
    this.form.get("insertDate").setValue(this.timestampFormatPipe.transform(this.device.insertDate));
    this.form.get("insertUser").setValue(this.device.insertUser);
    this.form.get("updateDate").setValue(this.timestampFormatPipe.transform(this.device.updateDate));
    this.form.get("updateUser").setValue(this.device.updateUser);
    this.form.get("optLock").setValue(this.device.optLock);
    this.form.markAsPristine();
  }

  ngOnDestroy(): void {
  }
}
